class HeroScroll extends window.BAO.CustomElement() {
  static get requiredExternalElements () {
    return ['section']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.onClick = this.onClick.bind(this)

    this.addEventListener('click', this.onClick)
  }

  onClick () {
    const sectionHeight = this.externalEls?.section?.element.offsetHeight

    window.scrollTo(0, `${sectionHeight}`)
  }
}

if (!customElements.get('hero-scroll')) {
  customElements.define('hero-scroll', HeroScroll)
}
